var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.66895C20 6.54721 19.1571 4.51238 17.6569 3.01209C16.1566 1.5118 14.1217 0.668945 12 0.668945C9.87827 0.668945 7.84344 1.5118 6.34315 3.01209C4.84285 4.51238 4 6.54721 4 8.66895C4 18.0023 0 20.6689 0 20.6689H24C24 20.6689 20 18.0023 20 8.66895Z",
    fill: "#20A8E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3047 26.0024C14.0703 26.4065 13.7339 26.742 13.329 26.9751C12.9242 27.2083 12.4652 27.331 11.9981 27.331C11.5309 27.331 11.0719 27.2083 10.6671 26.9751C10.2623 26.742 9.92582 26.4065 9.69141 26.0024",
    stroke: "#20A8E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIcon);
export default __webpack_public_path__ + "static/media/alerts_icon.2999d773677d113d3c7c7db189a96521.svg";
export { ForwardRef as ReactComponent };